import {
    IConfigControlButton,
    IConfigControlImage,
    IConfigControlLabel,
    IConstraintButtonControl,
    IControlType,
    ICustomButtonControl,
    IImageControl,
    ILabelControl,
    IPanelButtonControl,
    IServerButtonControl,
    ISpacerControl,
} from '@se/cp.common';
import { DataBinding } from '@se/se.ui.html5';
import { rowProportional } from '../utils/control-grid';

import { CpControl } from './cp-control';

export class CpGenericControl extends CpControl {
    readonly controlTypeGroup = 'Generic';

    readonly config: IConfigControlLabel | IConfigControlImage | IConfigControlButton;

    readonly _heightHint: number;

    constructor(
        control:
            | IConstraintButtonControl
            | ICustomButtonControl
            | IImageControl
            | ILabelControl
            | IPanelButtonControl
            | IServerButtonControl
            | ISpacerControl,
        readonly context?: DataBinding
    ) {
        super(control);

        this.config = control.config[0];

        this._heightHint = this.calculateHeight();
    }

    canAlignToBottom() {
        switch (this.controlType) {
            case IControlType.Image:
            case IControlType.Spacer:
                return true;
            default:
                return false;
        }
    }

    getHeightHint() {
        return this._heightHint;
    }

    private calculateHeight() {
        switch (this.controlType) {
            case IControlType.Label:
                return 27;
            case IControlType.ConstraintButton:
            case IControlType.CustomButton:
            case IControlType.ServerButton:
            case IControlType.PanelButton:
                return 45;
            case IControlType.Image:
            case IControlType.Spacer:
                return rowProportional(this.rowSpan);
            default:
                return 0;
        }
    }
}
